import './config';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Provider} from 'react-redux';
import store from './stores/configure-store';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {ClientId} from './const/dataEnum';
import FmlxErrorBoundary from './components/ErrorBoundary/FmlxErrorBoundary';
import {FmlxButton} from 'fmlx-common-ui';

const Root = () => {
  const [state, setState] = useState({
    showStackTrace: false,
  });

  const refreshButton = () => <FmlxButton size="xl" onClick={() => window.location.reload()} label="Refresh"/>;

  const showDetailButton = () => (
    <FmlxButton
      size="xl"
      onClick={() => setState({...state, showStackTrace: !state.showStackTrace})}
      variant="outline"
      label={state.stateStackTrace ? 'Hide Detail' : 'See Detail'}
    />
  );

  return (
    <FmlxErrorBoundary
      showStackTrace={state.showStackTrace}
      actions={[refreshButton(), showDetailButton()]}
      message="There has been an error that can't be recovered. Please refresh this page to see if it fixes the problem or contact melati@formulatrix.com if the problem persists."
    >
      <App/>
    </FmlxErrorBoundary>
  );
};

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <GoogleOAuthProvider clientId={ClientId}>
      <Root/>
    </GoogleOAuthProvider>
  </Provider>,
  // </React.StrictMode>
  document.getElementById('root')
);
